import { apiGet, apiPatch, apiPost } from '@/infrastructure/api-client';
import type { AdminRange, ErrorDisposition } from '@/domain/admin/contracts';

export type AdminSection = 'overview' | 'usage' | 'ai' | 'errors' | 'requests' | 'health';

export function getAdminSection(
  section: AdminSection,
  range: AdminRange,
  search = '',
): Promise<Record<string, unknown>> {
  const endpoint = section === 'ai' ? 'ai-usage' : section;
  return apiGet(`/api/admin/${endpoint}?range=${range}${search}`);
}

export function getAdminErrorDetail(fingerprint: string) {
  return apiGet<Record<string, unknown>>(`/api/admin/errors/${encodeURIComponent(fingerprint)}`);
}
export function getAdminRequestDetail(requestId: string) {
  return apiGet<Record<string, unknown>>(`/api/admin/requests/${encodeURIComponent(requestId)}`);
}
export function updateErrorDisposition(
  fingerprint: string,
  status: ErrorDisposition,
  note: string | null,
) {
  return apiPatch<{ ok: true }>(`/api/admin/errors/${encodeURIComponent(fingerprint)}`, {
    status,
    note,
  });
}
export function runAdminCleanup() {
  return apiPost('/api/admin/cleanup', { confirmation: 'CLEANUP' });
}
